import { Customer } from "../customer/Customer"
import { Note } from "../note/Note"
import { User } from "../user/User"
import { AuditableResponse } from "../common/AuditableResponse"
import { QuotePartDetails } from "./QuotePartDetails"
import { QuoteServiceDetails } from "./QuoteServiceDetails"

export class QuoteDetails extends AuditableResponse {
  id: number
  sentForCustomerApproval: boolean
  approvedDate?: string
  approvedByUser?: User
  customerSuppliedParts: string
  total: number
  cartridgeId?: number
  customerId?: number
  customer?: Customer
  buildTypeId?: number
  notes: Note[]
  quoteParts: QuotePartDetails[]
  quoteServices: QuoteServiceDetails[]
  partsDiscountPercentage: number
  partsTotal: number
  servicesDiscountPercentage: number
  servicesTotal: number

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(id: number, sentForCustomerApproval?: boolean, approvedDate?: string, approvedByUserJson?: any, customerSuppliedParts?: string, total?: number, cartridgeId?: number, customerId?: number, customerJson?: any, buildTypeId?: number, notesJson?: any, quotePartsJson?: any, quoteServicesJson?: any, partsDiscountPercentage?: number, partsTotal?: number, servicesDiscountPercentage?: number, servicesTotal?: number, createdByUserJson?: any, createdDate?: string, lastModifiedByUserJson?: any, lastModifiedDate?: string) {
    super(createdByUserJson, createdDate, lastModifiedByUserJson, lastModifiedDate)
    this.id = id
    this.sentForCustomerApproval = sentForCustomerApproval ?? false
    this.approvedDate = approvedDate
    this.approvedByUser = approvedByUserJson ? new User(approvedByUserJson) : undefined
    this.customerSuppliedParts = customerSuppliedParts ?? ''
    this.total = total ?? 0
    this.cartridgeId = cartridgeId
    this.customerId = customerId
    this.buildTypeId = buildTypeId
    this.partsDiscountPercentage = partsDiscountPercentage ?? 0
    this.partsTotal = partsTotal ?? 0
    this.servicesDiscountPercentage = servicesDiscountPercentage ?? 0
    this.servicesTotal = servicesTotal ?? 0
    this.customer = customerJson ? customerJson as Customer : undefined
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.notes = notesJson ? notesJson.map((n: any) => new Note(n.id, n.content, n.customerVisible, n.lastModifiedByUser, n.lastModifiedDate)) : []
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.quoteParts = quotePartsJson ? quotePartsJson.map((q: any) => new QuotePartDetails(q.id, q.displayOrder, q.name, q.notes, q.price)) : []
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.quoteServices = quoteServicesJson ? quoteServicesJson.map((q: any) => new QuoteServiceDetails(q.id, q.description, q.name, q.notes, q.price, q.serviceFieldValues)) : []
  }
}
